import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10",
      cy: "10",
      r: "9.25",
      stroke: "#D9D9D9",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M0 10C1.14805e-07 8.68678 0.258658 7.38642 0.761205 6.17316C1.26375 4.95991 2.00035 3.85752 2.92893 2.92893C3.85752 2.00034 4.95991 1.26375 6.17317 0.761204C7.38642 0.258657 8.68678 -4.85303e-07 10 0C11.3132 4.85304e-07 12.6136 0.258659 13.8268 0.761206C15.0401 1.26375 16.1425 2.00035 17.0711 2.92894C17.9997 3.85752 18.7363 4.95991 19.2388 6.17317C19.7413 7.38643 20 8.68679 20 10L10 10L0 10Z",
      fill: "#D9D9D9"
    }, null, -1)
  ]))]))
}
export default { render: render }